import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import VendorListScreen from '../component/VendorListScreen';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import RoutePath from '../utils/routes/RoutePath';
import PaginationComponenent from '../component/Pagination';
import Constants, { LIMIT } from '../utils/Constants';
import { toast } from 'react-toastify';
import NoDataFound from '../component/NoDataFound';
import { getSavedPage, setSavedPage } from '../utils/paginationState';

const PAGINATION_KEY = 'vendor-list';

class VendorList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageNumber: getSavedPage(PAGINATION_KEY),
            totalItem: '',
            searchText: '',
        }
    }
    componentDidMount() {
        this.getVendorList()
    }

    getVendorList = (isUpdate) => {
        const { searchText } = this.state;
        let params = {
            limit: LIMIT,
            pageNumber: this.state.pageNumber - 1,
            search: searchText,
        }
        const callback = (response) => {
            if (response) {
                this.setState({ totalItem: response.response.totalItems })
            }
        }
        this.props.vendorList(params, callback)
    }

    updateActive = (e, obj) => {
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getVendorList(true)
            }
            else {
                toast.error(response.response_message)
            }
        }
        let params = {
            id: obj.id,
            isActive: e
        }
        this.props.updateVendor(params, callback, (this.props.location.pathname === RoutePath.ADMIN_VENDOR_LIST))
    }
    onChangePagination = (pageNumber) => {
        const { searchText } = this.state;
        let params = {
            pageNumber: (pageNumber - 1),
            limit: LIMIT,
            search: searchText,
        }
        this.props.vendorList(params, '', "")
        setSavedPage(PAGINATION_KEY, pageNumber);
        this.setState({ pageNumber: pageNumber })
    }
    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchText: value, pageNumber: 1 }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getVendorList();
        });
    }
    clearSearch = () => {
        this.setState({ searchText: '', pageNumber: 1 }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getVendorList();
        });
    }
    render() {
        const { pageNumber, searchText } = this.state
        const { getVendorList = {} } = this.props
        const { vendorList = {}, isLoading } = getVendorList
        const { vendors = [], totalItems = 0 } = vendorList;
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div className='addButton'>
                            <div className="add-btn">
                                <button className="btn add-item" onClick={() => this.props.history.push(RoutePath.ADD_ADMIN_VENDOR)} type="button"><i className="fa-solid fa-plus me-3"></i>{Constants.ADD_NEW_VENDOR}</button>
                            </div>
                            <div className="add-btn search-box">
                                <input
                                    className="form-control search-input"
                                    placeholder="Search by name / email"
                                    value={searchText}
                                    onChange={this.handleSearchChange}
                                />
                                {searchText ? <button type="button" className="search-clear-btn" onClick={this.clearSearch}>x</button> : null}
                            </div>
                        </div>
                        <VendorListScreen
                            vendors={vendors}
                            updateActive={(value, index) => this.updateActive(value, index)}
                            currentPage={pageNumber}
                        />
                        <div className='page-content'>
                            {
                                totalItems > (LIMIT - 1) && <PaginationComponenent currentPage={pageNumber} countValue={totalItems} onChangeHandle={this.onChangePagination} />
                            }
                        </div>
                    </div>
                </div>
                {isLoading && <AppLoader />}

            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getVendorList: Actions.getCustomerCallList(state)
    }
};

export default withRouter(connect(mapStateToProps, {
    vendorList: Actions.vendorListAction,
    updateVendor: Actions.updateVendorAction,
})(VendorList))